import { toast } from 'react-toastify';
import messages from 'constants/messages';
import { EContractTermOptionType, EProductField, IVolumeOption } from 'store/field-options/types';
import { updateProductField } from 'store/deal-edit/actions';
import { EFormulaModalType } from 'store/formula-entry/types';

function showBaseBatnaWarning() {
  toast.dismiss();
  toast.warn(messages.warnings.baseBatnaRequired);
}

export function processFinancialCapCheckBox(
  isBaseBatnaComplete: boolean,
  capValue: string | undefined,
  index: number,
  capEnabled: boolean = false
) {
  if (!isBaseBatnaComplete) {
    showBaseBatnaWarning();
  } else if (capValue) {
    updateProductField(index, EProductField.CAP_ENABLED, !capEnabled);
  }
}

export function processFinancialCapGeneralClick(
  isBaseBatnaComplete: boolean,
  index: number,
  startFormulaEdit: Function
) {
  if (isBaseBatnaComplete) {
    startFormulaEdit({
      productIndex: index,
      modalType: EFormulaModalType.CAP,
    });
  } else {
    showBaseBatnaWarning();
  }
}

export function processFinancialFloorCheckBox(
  isBaseBatnaComplete: boolean,
  floorValue: string | undefined,
  index: number,
  floorEnabled: boolean = false
) {
  if (!isBaseBatnaComplete) {
    showBaseBatnaWarning();
  } else if (floorValue) {
    updateProductField(index, EProductField.FLOOR_ENABLED, !floorEnabled);
  }
}

export function processFinancialFloorGeneralClick(
  isBaseBatnaComplete: boolean,
  index: number,
  startFormulaEdit: Function
) {
  if (isBaseBatnaComplete) {
    startFormulaEdit({
      productIndex: index,
      modalType: EFormulaModalType.FLOOR,
    });
  } else {
    showBaseBatnaWarning();
  }
}

export function processVolumePushCheckBox(
  isBaseBatnaComplete: boolean,
  push: { enabled: boolean } | undefined,
  index: number
) {
  if (!isBaseBatnaComplete) {
    showBaseBatnaWarning();
  } else if (push) {
    updateProductField(index, EProductField.PUSH, {
      ...push,
      enabled: !push.enabled,
    });
  }
}

export function processVolumePushGeneralClick(isBaseBatnaComplete: boolean, index: number, startFormulaEdit: Function) {
  if (isBaseBatnaComplete) {
    startFormulaEdit({
      productIndex: index,
      modalType: EFormulaModalType.PUSH,
    });
  } else {
    showBaseBatnaWarning();
  }
}

export function processVolumePullCheckBox(
  isBaseBatnaComplete: boolean,
  pull: { enabled: boolean } | undefined,
  index: number
) {
  if (!isBaseBatnaComplete) {
    showBaseBatnaWarning();
  } else if (pull) {
    updateProductField(index, EProductField.PULL, {
      ...pull,
      enabled: !pull.enabled,
    });
  }
}

export function processVolumePullGeneralClick(isBaseBatnaComplete: boolean, index: number, startFormulaEdit: Function) {
  if (isBaseBatnaComplete) {
    startFormulaEdit({
      productIndex: index,
      modalType: EFormulaModalType.PULL,
    });
  } else {
    showBaseBatnaWarning();
  }
}

export function processVolumContractTermCheckBox(
  isBaseBatnaComplete: boolean,
  extension: IVolumeOption | undefined,
  earlyTerm: IVolumeOption | undefined,
  index: number
) {
  let optionType;
  let option;

  if (extension) {
    optionType = EContractTermOptionType.EXTENSION;
    option = extension;
  } else if (earlyTerm) {
    optionType = EContractTermOptionType.EARLY_TERMINATION;
    option = earlyTerm;
  }

  if (!isBaseBatnaComplete) {
    showBaseBatnaWarning();
  } else if (optionType && option) {
    updateProductField(index, optionType, {
      ...option,
      enabled: !option.enabled,
    });
  }
}

export function processVolumeContractTermGeneralClick(
  isBaseBatnaComplete: boolean,
  index: number,
  startFormulaEdit: Function
) {
  if (isBaseBatnaComplete) {
    startFormulaEdit({
      productIndex: index,
      modalType: EFormulaModalType.CONTRACT_TERM,
    });
  } else {
    showBaseBatnaWarning();
  }
}
